import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../PublicHeader";
import Footer from "../Footer";
import axios from "../../api/axiosInstance";
import {FaCheck} from "react-icons/fa";

const CheckMark = FaCheck as unknown as React.FC;

interface Plan {
    id: number;
    name: string;
    price_monthly: number;
    price_yearly: number;
    features: string[];
    bestValue?: boolean;
}

const Pricing = () => {
    const [plans, setPlans] = useState<Plan[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPlans = async () => {
            try {
                const res = await axios.get<Plan[]>("/subscription/public_subscriptions");
                setPlans(res.data);
            } catch (err) {
                console.error("Failed to load plans", err);
            } finally {
                setLoading(false);
            }
        };
        fetchPlans();
    }, []);

    return (
        <div className="min-h-screen bg-gray-100">
            <Header />
            <div className="max-w-6xl mx-auto px-6 py-12 text-center">
                <h2 className="text-4xl font-bold text-blue-600 mb-4">💳 Pricing Plans</h2>
                <p className="text-gray-600 mb-8">Choose the plan that fits your restaurant best.</p>

                {loading ? (
                    <div className="grid md:grid-cols-3 gap-6">
                        {[1, 2, 3].map((_, i) => (
                            <div key={i} className="bg-white p-6 rounded-lg shadow animate-pulse">
                                <div className="h-6 bg-gray-300 rounded mb-4 w-1/2 mx-auto"></div>
                                <div className="h-4 bg-gray-200 rounded mb-4 w-1/3 mx-auto"></div>
                                <ul className="space-y-2 mb-6">
                                    {[1, 2, 3].map((_, idx) => (
                                        <li key={idx} className="h-3 bg-gray-200 rounded w-3/4 mx-auto"></li>
                                    ))}
                                </ul>
                                <div className="h-10 bg-gray-300 rounded w-full"></div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="grid md:grid-cols-3 gap-6">
                        {plans.map((plan) => (
                            <div
                                key={plan.name}
                                className={`bg-white p-6 rounded-lg shadow-lg ${
                                    plan.bestValue ? "border-2 border-blue-600" : ""
                                }`}
                            >
                                <h3 className="text-xl font-bold mb-2">{plan.name}</h3>
                                <p className="text-gray-600 mb-4">
                                    {`$${plan.price_monthly}/mo`}
                                </p>
                                <div className="flex justify-center">
                                    <ul className="text-gray-700 mb-6 space-y-2">
                                        {plan.features.map((feature, idx) => (
                                            <li key={idx} className="flex items-start gap-2 text-left">
                                                <span className="text-green-500 mt-1"><CheckMark/></span>
                                                <span>{feature}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                {plan.name === "Enterprise" ? (
                                    <a
                                        href="mailto:sales@savoryai.io"
                                        className="bg-blue-600 text-white px-4 py-2 rounded inline-block"
                                    >
                                        Contact Sales
                                    </a>
                                ) : (
                                    <Link
                                        to="/login"
                                        className="bg-blue-600 text-white px-4 py-2 rounded inline-block"
                                    >
                                        Get Started
                                    </Link>
                                )}

                            </div>
                        ))}
                    </div>
                )}
            </div>
            <Footer/>
        </div>
    );
};

export default Pricing;
